import cx from "ui/cx";
import styles from "./DataTable.module.scss";

export default function DataTableLoading() {
  const cols = Array.from({ length: 5 }, (_, i) => i);
  const rows = Array.from({ length: 10 }, (_, i) => i);
  return (
    <div className={cx(styles.table, styles.loading)}>
      <div className={styles.rowWrapper} role="rowgroup">
        <div className={styles.header}>
          {cols.map((col) => (
            <div className={styles.cell} key={col} />
          ))}
        </div>
      </div>
      <div className={styles.body}>
        {rows.map((row) => (
          <div className={styles.rowWrapper} role="rowgroup" key={row}>
            <div className={styles.row} role="row">
              {cols.map((col) => (
                <div className={styles.cell} key={col} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
